import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AclService {
  constructor(
    private http: HttpClient,
    private authService: AuthService,
    @Inject('env') private env: any
  ) {}

  public CurrentUserHasMinimumRole(role: string, clientCode?: string): Observable<boolean> {
    const userId = this.authService.user.UserId;
    return this.HasMinimumRoleByName(userId, role, clientCode);
  }
  public HasMinimumRoleByName(
    userId: string,
    role: string,
    clientCode?: string
  ): Observable<boolean> {
    let query = new HttpParams();
    query = query.append('model.UserId', userId);
    query = query.append('model.Role', role);
    if (clientCode != null) {
      query = query.append('model.OfficeGroup', this.env.defaultOfficeGroup);
      query = query.append('model.ClientGroup', clientCode);
    }

    let headers = new HttpHeaders();
    //We want to cache these requests
    headers = headers.set('X-Cache-Lifetime', '86400');
    return this.http.get<boolean>(`${this.env.apiUrlRoot}/Acl/HasMinimumRoleByName`, {
      headers,
      params: query
    });
  }
  public CurrentUserIsInRole(role: string, clientCode?: string): Observable<boolean> {
    const userId = this.authService.user.UserId;
    return this.IsInRole(userId, role, clientCode);
  }
  public IsInRole(userId: string, role: string, clientCode?: string): Observable<boolean> {
    let query = new HttpParams();
    query = query.append('model.UserId', userId);
    query = query.append('model.Role', role);
    if (clientCode != null) {
      query = query.append('model.OfficeGroup', this.env.defaultOfficeGroup);
      query = query.append('model.ClientGroup', clientCode);
    }

    let headers = new HttpHeaders();
    //We want to cache these requests
    headers = headers.set('X-Cache-Lifetime', '86400');
    return this.http.get<boolean>(`${this.env.apiUrlRoot}/Acl/IsInRoleByName`, {
      headers,
      params: query
    });
  }
  public CurrentUserAccessCheck(
    overrideRole: string,
    requiredRole: string,
    clientCode: string
  ): Observable<boolean> {
    const userId = this.authService.user.UserId;
    return this.AccessCheck(userId, overrideRole, requiredRole, clientCode);
  }
  public AccessCheck(
    userId: string,
    overrideRole: string,
    requiredRole: string,
    clientCode: string
  ) {
    let initial = this.HasMinimumRoleByName(userId, overrideRole, clientCode);
    if (overrideRole === 'CSR' || overrideRole === 'CSR1') {
      initial = this.HasMinimumRoleByName(userId, overrideRole);
    }
    return initial.pipe(
      mergeMap(result => {
        if (result) {
          return of(result);
        } else {
          return this.IsInRole(userId, requiredRole, clientCode);
        }
      })
    );
  }
}
